import { Badge } from '@mantine/core';
import { SecretMenuTool } from './secretMenuCatalogue';

export default function SecretMenuToolMarkers({ tool }: { tool: SecretMenuTool }) {
  return (
    <>
      {tool.dangerous && (
        <Badge color="red" variant="light" size="sm">
          Dangerous
        </Badge>
      )}
      {tool.deprecated && (
        <Badge color="gray" variant="light" size="sm">
          Deprecated
        </Badge>
      )}
    </>
  );
}
